/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import GradientPaper from "../../../GradientComponents/GradientPaper";
import Typography from "@mui/material/Typography";
import divorceHighlightBoxStyle from "./divorceHighlightBoxStyle";
import { Link } from "react-router";

const DivorceHighlightBox = () => {
  return (
    <GradientPaper sx={divorceHighlightBoxStyle.paper}>
      <Typography variant={"h3"}>Scheidung online - professionelle, anwaltliche Beratung inklusive!</Typography>
      <p>
        Alles online und per Telefon abklären und jederzeit perfekt informiert sein - Ein Anwaltsbesuch vor Ort ist nicht notwendig, können wir aber gerne
        ermöglichen! Sie geben in Ihrer Servicewelt ganz einfach die Daten zu Ihrer Scheidung an und wir beraten Sie zu all Ihren Fragen!
      </p>
      <p>
        Wir sind Fachanwälte im Familienrecht, also spezialisierte <strong>Scheidungsanwälte</strong>, durch die Sie eine sehr schnelle und persönliche Beratung erhalten!
      </p>
      <Typography sx={{ color: "primary.main", textAlign: "center" }}>
        <Link to={"#top-checkin"}>Jetzt direkt starten und mit professioneller Unterstützung scheiden lassen!</Link>
      </Typography>
    </GradientPaper>
  );
};

export default DivorceHighlightBox;
